import React, { useEffect, useState } from "react";
import Card from "../../../components/uikit/components/Card/Card";
import { createProjectHeading, getRouteId, INSIGHTCARD } from "../../../constants/constant";
import ButtonComponent from "../../../components/uikit/components/Button/ButtonComponent";
import {
  setCurrentMVOCDetail,
  setSelectedInsight,
  setStepcompleted,
} from "../../../features/product/projectSlice";
import { useDispatch, useSelector } from "react-redux";
import { clarityNav } from "../../../services/api/clarityNav/apiService";

const Insight = ({onDisableMVOCChange,apiCallcheck}) => {
  // dispatch hook
  const dispatch = useDispatch();
  const [disableMVOC, setDisableMVOC] = useState(false);
  const stepper = useSelector((state) => state.product.stepCompleted);
  const [showButton, setShowButton] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("MVOC Insights");
  const handlePlanChange = (planName) => {
    setSelectedPlan(planName);
    dispatch(setSelectedInsight(planName));
    // if (planName === "MVOC Insights") {
    // }
  };
  const handleSubmit = () => {
    // Save to Redux
    dispatch(setSelectedInsight(selectedPlan));
    dispatch(setStepcompleted(2));
  };
  const [fetchMvocDataById] = clarityNav.endpoints.getMvocDataFromProjectId.useLazyQuery();
  const Project_id =useSelector((state) => state?.product?.currentProjectDetail?.id);
  useEffect(() => {
    const fetchData = async () => {
      try {
        //first time API call check
        if (stepper === 1) {
          apiCallcheck(true);
          return;
        }
        const mvocData = await fetchMvocDataById(Project_id);
        if(mvocData?.isSuccess && mvocData?.data?.success && mvocData?.data?.result){
          dispatch(setCurrentMVOCDetail(mvocData?.data?.result));
          setDisableMVOC(true);
          onDisableMVOCChange(true);
        }
        if (mvocData) {
          setShowButton(true);
        }
      } catch (error) {
        console.error("Error fetching MVOC data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <div>
      <form className="container-fluid pt-3">
        <div className="card w-100 border-none">
          <span className="project-title-text">{createProjectHeading.SELECT_INSIGHT}</span>

          <div className="card-container gap-4">
            {INSIGHTCARD.map((plan) => (
              <Card
                key={plan.name}
                name={plan.name}
                cost={plan.cost}
                cycle={plan.cycle}
                details={plan.details}
                isChecked={selectedPlan === plan.name}
                // isDisabled={
                //   plan.name !== "MVOC Insights" &&
                //   selectedPlan === "MVOC Insights"
                // }
                onChange={() => handlePlanChange(plan.name)}
              />
            ))}
          </div>
        </div>
        {!showButton && (stepper !== 1 && stepper !==2 && stepper !==3) &&(
          <div className="d-flex w-100 my-3 justify-content-end">
            <ButtonComponent
              variant="contained"
              onClick={handleSubmit}
              btnType="primary"
              text="Save & Proceed"
              className="btnPrimary"
            />
          </div>
        )}
      </form>
    </div>
  );
};

export default Insight;
